import { Injectable } from '@angular/core';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';

import { MONTHS, WEEKDAYS } from '../models/period-picker.model';

@Injectable()
export class DatepickerI18nService extends NgbDatepickerI18n {
  constructor(private _translate: TranslateService) {
    super();
  }

  getWeekdayLabel(weekday: number): string {
    return !WEEKDAYS[weekday - 1] || this._translate.instant(WEEKDAYS[weekday - 1]);
  }

  getMonthShortName(month: number): string {
    return !MONTHS[month - 1] || this._translate.instant(MONTHS[month - 1]);
  }

  getMonthFullName(month: number): string {
    return !MONTHS[month - 1] || this._translate.instant(MONTHS[month - 1]);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    const dayjsDate = dayjs()
      .tz()
      .set({ year: date.year, month: date.month - 1, date: date.day });
    return `${dayjsDate.format('dddd')}, ${dayjsDate.format('LL')}`;
  }
}
